import { useQuery } from "react-query";
import axios from "axios";
import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";

const useFetchVesselDocuments = (vesselId) => {
  const { token } = useContext(AuthContext);

  const fetchVesselDocuments = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/vessel/documents/${vesselId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status !== 200) {
        throw new Error("Failed to fetch vessel documents.");
      }

      return response.data; 
    } catch (error) {
      throw new Error(error.message || "An error occurred while fetching vessel documents.");
    }
  };

  return useQuery(["vesselDocuments", vesselId], fetchVesselDocuments);
};

export default useFetchVesselDocuments;
